import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ListRequest} from '../../../interfaces/list-request.interface';
import {BaseApiClient} from '../../../shared/api-clients/base-api-client';
import {BASE_SITE, OCC_BASE_PATH} from '../../../shared/constants/api';
import {SearchResponse} from '../interface/search.interface';

@Injectable({providedIn: 'root'})
export class SearchApiClient extends BaseApiClient {
  override getBaseRawUrl(): string {
    return `${OCC_BASE_PATH}${BASE_SITE}/search`;
  }

  // Not needed for this client, but must be implemented due to abstract signature
  override getBaseBinaryUrl(): string {
    return '';
  }

  public getAllSearchedOrders(request: ListRequest): Observable<SearchResponse> {
    return this.client.post<SearchResponse>(`${this.rawApi}/orders`, {
      filters: request.filters,
      conjunctionType: request.conjunctionType,
      mode: request.mode,
    });
  }
}
